import React, {useContext, useEffect, useRef, useState} from 'react';
import './DetailDocumentIssuance.scss';
import DynaButton from "../../../DynaView/DynaButton";
import UtilsFunctions from "../../../../../utils/UtilsFunctions";
import {SetPrintDataContext} from "../../../../../Pages";
import {useNavigate} from "react-router-dom";

const RowShowLevel = ({sendData, setSendData}) => {

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const inputRef = useRef(null);
  const [priceData, setPriceData] = useState({
    bed: 0,
    bes: 0,
    bedPercent: 50,
    besPercent: 50,
  })

  useEffect(() => {
    let bed = 0
    let bes = 0
    sendData?.documentDetails.forEach((item) => {
      bed = bed + +item?.bed
      bes = bes + +item?.bes
    })
    const total = bed + bes;
    const bedPercent = total !== 0 ? (bed / total) * 100 : 50;
    const besPercent = total !== 0 ? (bes / total) * 100 : 50;

    setPriceData({
      bed: bed,
      bes: bes,
      bedPercent: bedPercent,
      besPercent: besPercent,
    })
  }, [sendData]);

  const customEncode = (str) => {
    let encodedStr = '';
    for (let i = 0; i < str.length; i++) {
      encodedStr += String.fromCharCode(str.charCodeAt(i) + 5);
    }
    return encodedStr;
  };

  const customDecode = (encodedStr) => {
    let decodedStr = '';
    for (let i = 0; i < encodedStr.length; i++) {
      decodedStr += String.fromCharCode(encodedStr.charCodeAt(i) - 5);
    }
    return decodedStr;
  };

  const handleSave = () => {
    try {
      const jsonData = JSON.stringify(sendData);
      const hashedData = customEncode(jsonData);
      const fileData = new Blob([hashedData], {type: 'text/plain'});
      const url = URL.createObjectURL(fileData);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${sendData?.documentCode}-شماره سند.txt`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const hashedData = event.target.result;
        const jsonData = customDecode(hashedData);
        const fileData = JSON.parse(jsonData);
        setSendData(fileData);
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    };
    reader.readAsText(file);
  };

  const printHandel = () => {
    const sendPrintData = {
      type: "ControlUnderTablePrint",
      data: sendData,
      title: "سند حسابداری"
    };
    setprint(sendPrintData);
    navigate("/factorprint");
  }

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
        handleSave();
      }
      if (e.ctrlKey && e.key === 'o') {
        e.preventDefault();
        inputRef.current.click()
      }
      if (e.ctrlKey && e.key === 'p') {
        e.preventDefault();
        printHandel()
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [sendData]);

  return (
    <div className={"RowShowLevel"}>
      <div className={"grid-box"}>
        <DynaButton className={"simple-but-no-bac"}
                    type={"button"}
                    onClick={() => inputRef.current.click()}>بارگزاری فایل</DynaButton>
        <input type="file" accept="text/plain" ref={inputRef} onChange={handleFileUpload}/>
        <DynaButton className={"simple-but-no-bac"}
                    type={"button"}
                    onClick={handleSave}>ذخیره فایل</DynaButton>
        <DynaButton className={"simple-but-no-bac"}
                    type={"button"}
                    onClick={printHandel}>پرینت</DynaButton>
      </div>
      <div className={"grid-box"} style={{justifyContent: "space-between"}}>
        <h6>
          بدهکار : {UtilsFunctions.addCommas(priceData?.bed)}
        </h6>
        <h6>
          بستانکار : {UtilsFunctions.addCommas(priceData?.bes)}
        </h6>
        <h6>
          مانده تراز شدن : {UtilsFunctions.addCommas(+priceData?.bed - +priceData?.bes)}
        </h6>
      </div>
      <div className={"grid-box show-LevelBox"}>
        <div className="LevelBox class-bed" style={{width: `${priceData?.bedPercent + "%"}`}}>
          <span>بدهکار</span>
        </div>
        <div className="LevelBox class-bes" style={{width: `${priceData?.besPercent + "%"}`}}>
          <span>بستانکار</span>
        </div>
      </div>
    </div>
  );
};

export default RowShowLevel;